import { Map } from 'immutable';

export default Map({
  loading: false,
  cancelLoading: false,
  error: null,
  data: null,
});
